import type { RenderingStrategy } from '@/cms/rendering-strategy/types';
import { mvcRenderingStrategy } from '@/cms/rendering-strategy/mvcRenderingStrategy';
import { hybridRenderingStrategy } from '@/cms/rendering-strategy/hybridRenderingStrategy';
import { fullReactRenderingStrategy } from '@/cms/rendering-strategy/fullReactRenderingStrategy';
import type { PageRegistry } from '@/cms/pageRegistryTypes';

/**
 * TODO DocumentPageProps is a type we should work on.
 * At first I create to contain different props set for _document.tsx MyDocument component
 * Now we are using it in a different way...
 * Maybe we need som sort of partial type and define it separately, understand the props funnel and which is a
 * subset/superset of the other.
 * Maybe it just a rename...
 *
 * Now can be
 * -> getStaticProps return type
 *      -> UniformPageProps depending on if is a page that exist in sitecore or not
 *      -> Normalized set of data (MinimumSlugProps)
 *      -> A mix of both
 * -> custom pages (500, 404, etc) props -> has metadata and some other custom fields not present on the other...
 * -> ??
 */
interface RenderingStrategyPageProps {
  page: {
    fields: {
      useFullReactPage: boolean;
    };
  };
  hasReactComponents?: boolean;
}

function createRenderingStrategy(
  documentPageProps: RenderingStrategyPageProps,
  pageRegistry: PageRegistry
): RenderingStrategy {
  if (documentPageProps.page?.fields?.useFullReactPage || pageRegistry.isPageRegistered(documentPageProps)) {
    return fullReactRenderingStrategy();
  }

  /**
   *   TODO: This commented code is the current behavior, but we want to maintain this? I think we should simplify,
   *   but we need to clarify the criteria.
   *
   *   `hasReactComponents` approach
   *      -> gives control to sitecore (pros/cons?)
   *      -> is inconsistent with pageRegistry approach in full React
   *
   *   `reactHybridPageRegistry` approach
   *      -> gives control to next app (pros/cons?)
   *      -> is consistent with pageRegistry approach in full React
   */
  if (documentPageProps.hasReactComponents /* || reactHybridPageRegistry.isTemplateRegistered(pageProps) */) {
    return hybridRenderingStrategy();
  }

  return mvcRenderingStrategy();
}

export default {
  createRenderingStrategy,
};
